module.exports = __webpack_public_path__ + "img/ruth@2x.428a90c8.png";